import React, {useEffect, useState} from 'react'
import {Row, Col} from 'antd'
import {useHistory} from 'react-router-dom'
import apiRequest from './hooks/apiRequest'
import Layouts from './components/Layouts'

const Home = () => {
  const history = useHistory()

  const [productList, setProductList] = useState([])
  const [username, setUsername] = useState(localStorage.getItem('username'))

  const fetchData = async () => {
    const response = await apiRequest(
      process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts',
      'GET',
    )
    if (response.success) {
      setProductList(response?.data?.data || [])
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleClick = data => {
    localStorage.setItem('productId', data.productid)
    localStorage.setItem('productName', data.productname)
    history.push('/claims')
  }

  return (
    <Layouts title="assets" classname="grid">
      <div className="ant-layout-content">
        <div className="dashboard-heading-top cards-heading text-center">
          <h1>Hello {username} !! </h1>
          <p>Please Select Insurance Product</p>
        </div>
        <Row gutter={[16, 16]}>
          {productList.map((value, index) => (
            <Col
              key={index}
              xs={24}
              sm={12}
              md={8}
              lg={8}
              className="custom-statcards buttons">
              <button
                onClick={() => handleClick(value)}
                className="primary card-body-bx yellow-bg text-left">
                <h4>{value.productname}</h4>
                <div className="card-icon-bx">
                  <img
                    src={require('../src/static/images/assets.png')}
                    alt="icon"
                  />
                </div>
              </button>
            </Col>
          ))}
        </Row>
      </div>
    </Layouts>
  )
}

export default Home
